import React from 'react'

import { InvoiceStatus } from '../../types'

import './StatusFilterCheckboxes.scss'

const DUE_STATUSES = [InvoiceStatus.OPEN, InvoiceStatus.OVERDUE]

const STATUS_OPTIONS: { value: string; label: string; description: string }[] = [
  { value: InvoiceStatus.DRAFT, label: 'Draft', description: 'Unfinished invoices' },
  { value: 'due', label: 'Due', description: 'Open and Overdue' },
  { value: InvoiceStatus.PAID, label: 'Paid', description: 'Payment received' },
]

type Props = {
  selectedStatuses: string[]
  onStatusChange: (statuses: string[]) => void
}

const StatusFilterCheckboxes: React.FC<Props> = ({ selectedStatuses, onStatusChange }) => {
  const isDueChecked =
    selectedStatuses.includes(InvoiceStatus.OPEN) || selectedStatuses.includes(InvoiceStatus.OVERDUE)

  const handleChange = (value: string, checked: boolean) => {
    if (value === 'due') {
      const next = checked
        ? Array.from(new Set([...selectedStatuses, ...DUE_STATUSES]))
        : selectedStatuses.filter((s) => !DUE_STATUSES.includes(s as InvoiceStatus))
      onStatusChange(next)
    } else {
      const next = checked
        ? [...selectedStatuses, value]
        : selectedStatuses.filter((s) => s !== value)
      onStatusChange(next)
    }
  }

  return (
    <div className="status-filter-checkboxes">
      <label className="form-label bold-label">Status</label>
      <div className="status-filter-checkboxes__group">
        {STATUS_OPTIONS.map(({ value, label, description }) => (
          <label
            key={value}
            className={`status-filter-checkboxes__item status-filter-checkboxes__item--${value}`}
          >
            <input
              type="checkbox"
              className="form-check-input"
              checked={value === 'due' ? isDueChecked : selectedStatuses.includes(value)}
              onChange={(e) => handleChange(value, e.target.checked)}
            />
            <span className="status-filter-checkboxes__text">
              <span className="status-filter-checkboxes__title">{label}</span>
              <span className="help-tip-text">{description}</span>
            </span>
          </label>
        ))}
      </div>
    </div>
  )
}

export default StatusFilterCheckboxes
